import { render } from "./Richieste.vue?vue&type=template&id=a8170170&scoped=true&ts=true"
import script from "./Richieste.vue?vue&type=script&lang=ts"
export * from "./Richieste.vue?vue&type=script&lang=ts"

import "./Richieste.vue?vue&type=style&index=0&id=a8170170&scoped=true&lang=css"

import exportComponent from "/Users/andrea/Sites/app_apib/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8170170"]])

export default __exports__